module.exports = __webpack_public_path__ + "img/MTABAPPDCBP.07e4ea29.svg";